import { GraphComponent, ScrollBarVisibility, ViewportChanges } from "yfiles";
import { ZOOM } from "../constants";
export default () => {
    const result = new GraphComponent();
    result.autoDrag = true;
    result.navigationCommandsEnabled = true;
    result.horizontalScrollBarPolicy = ScrollBarVisibility.NEVER;
    result.verticalScrollBarPolicy = ScrollBarVisibility.NEVER;
    result.animatedViewportChanges = ViewportChanges.ALL;
    result.zoom = ZOOM.DEFAULT;
    result.minimumZoom = ZOOM.MIN;
    result.maximumZoom = ZOOM.MAX;
    return result;
};
